export function EyeOpenIcon({ color = "black" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
      <path
        d="M6.03327 3.87744L5.73438 1.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.18968 4.46515L3.09375 2.34589"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5026 5.6922L1 3.87744"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9668 3.87744L8.26569 1.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.81055 4.46515L10.9065 2.34589"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.498 5.6922L13.0007 3.87744"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.0008 9.10042C7.97098 9.10042 8.75746 8.27924 8.75746 7.26627C8.75746 6.2533 7.97098 5.43213 7.0008 5.43213C6.03062 5.43213 5.24414 6.2533 5.24414 7.26627C5.24414 8.27924 6.03062 9.10042 7.0008 9.10042Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33984 7.2663C1.33984 7.2663 3.09424 3.80133 7.00065 3.80133C10.9071 3.80133 12.6615 7.2663 12.6615 7.2663C12.6615 7.2663 10.9071 10.7308 7.00065 10.7308C3.09424 10.7308 1.33984 7.2663 1.33984 7.2663Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
